<template lang="pug">
div
  .top-background
  .home.container
    .row
      monster-box.col-12
    event-box
    integration-box
</template>

<style lang="scss" scoped>
  .home {
    padding-top: 4em;
  }

  .top-background {
    z-index: -1;
    position: absolute;
    width: 100%;
    height: 736px;
    background-position: center;
    background-size: cover;
    background-image:
      image-set(
        url('../assets/forest-background.png') 1x,
        url('../assets/forest-background@2x.png') 2x,
        url('../assets/forest-background@3x.png') 3x,
      );
  }
</style>

<script>
import axios from 'axios';

import MonsterBox from './monsters/MonsterBox';
import EventBox from './events/EventBox';
import IntegrationBox from './integration/IntegrationBox';

export default {
  name: 'Home',
  components: {
    MonsterBox,
    EventBox,
    IntegrationBox,
  },
  mounted() {
    window.scrollTo(0, 0);
    window.amplitude.getInstance().logEvent('VISIT_HOME');

    this.showInitialAchievement();

    const { invite } = this.$route.query;
    if (invite) {
      axios.post(`/invites/${invite}/accept`);
    }
  },
  computed: {
    viewedAchievements() {
      return this.$store.state.viewedAchievements;
    },
  },
  methods: {
    showInitialAchievement() {
      if (this.viewedAchievements.greatFriendship) return;

      this.$notify({
        group: 'main',
        title: 'Achievement Unlocked!',
        text: 'Beginning of a Great Friendship',
      });

      this.$store.commit('setAchievement', { achievement: 'greatFriendship' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue